import Vue from "vue";
import VueRouter from "vue-router";

//重写push方法
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error);
};

// 例
import RouterChild from "@/routes/path/RouterChild";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/home",
    component: resolve => require(["@/views/Home/Home.vue"], resolve),
    meta: {
      title: "南昊AI教学提分平台",
      auth: 1,
      keepAlive: false,
    },
    children: RouterChild
  }
  
];

const router = new VueRouter({
  routes
});

import { get_login, getSkipToken } from "@/api/main.js"

let geturl = window.location.href 
let getqyinfo = geturl.split('?')[1]   //qycode=1001&qyname=%E4%BC%81%E4%B8%9A%E5%BF%99   截取到参数部分
let getqys = new URLSearchParams('?'+getqyinfo)  //将参数放在URLSearchParams函数中
let ticket = getqys.get('ticket')

router.beforeEach((to, from, next) => {
  if (to.path == "/"||to.path == "/home") {
      let param = {};
      param.ticket = ticket
      get_login(param).then(res => {
        if (res.data.code == 200) {
          localStorage.setItem('ydj_token', res.data.data.token);
          localStorage.setItem('ydjloginInfo',JSON.stringify(res.data.data))
          // let token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzY2hvb2xJZCI6IjUxNyIsInRlbE51bSI6IjgwMyIsInNjaG9vbGRiIjoic2FzY2hvb2xfMTAwOTAiLCJ1c2VyTmFtZSI6IuePreS4u-S7uyIsImV4cCI6MTc3NDUxODE5NywidXNlcklkIjoiNDAwMjMiLCJpYXQiOjE3NzQ1MDM3OTcsInNjaG9vbG5hbWUiOiLljZfmmIrlrp7pqozlrabmoKEifQ.aWQ6fVhD6mdXZge_SoNmus2RnqxO52sUYSUcMwy5xFs"
          // localStorage.setItem('ydj_token', token);
          // let info = {"userName":"班主任","token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzY2hvb2xJZCI6IjUxNyIsInRlbE51bSI6IjgwMyIsInNjaG9vbGRiIjoic2FzY2hvb2xfMTAwOTAiLCJ1c2VyTmFtZSI6IuePreS4u-S7uyIsImV4cCI6MTc3NDUxODE5NywidXNlcklkIjoiNDAwMjMiLCJpYXQiOjE3NzQ1MDM3OTcsInNjaG9vbG5hbWUiOiLljZfmmIrlrp7pqozlrabmoKEifQ.aWQ6fVhD6mdXZge_SoNmus2RnqxO52sUYSUcMwy5xFs"}
          // localStorage.setItem('ydjloginInfo',JSON.stringify(info))
          router.push({
            path:"/examlist"
          });
          
        }else {
          Vue.prototype.$message({
            showClose: true,
            message: res.data.msg,
            type: "warning"
          });
        }
      });
  } else {
    var islogin = localStorage.getItem('ydj_token')
    if (islogin) {
      next();
    } else {
      Vue.prototype.$message({
        message: '您尚未登录，请登录后再访问！',
        type: 'warning'
      });
      localStorage.removeItem('ydj_token')
    }
  }
});
router.afterEach(to => {
  if (to.meta.title) {
    document.title = to.meta.title;
    // 如果是 iOS 设备
    if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      const newPage = document.createElement("iframe");
      newPage.style.display = "none";
      document.body.appendChild(newPage);
      setTimeout(() => {
        document.body.removeChild(newPage);
      }, 300);
    }
  }
});

export default router;
